const regionsForSport = {
  basketball: [
    { name: "P1", value: "0000ff" },
    { name: "P1", value: "0055aa" },
    { name: "P1", value: "0053ac" },
    { name: "C1", value: "00ff00" },
    { name: "C1", value: "00a956" },
    { name: "T1", value: "ff00ff" },
    { name: "M", value: "00ffff" },
    { name: "T2", value: "800080" },
    { name: "P2", value: "ffff00" },
    { name: "P2", value: "ffac00" },
    { name: "P2", value: "ffaa00" },
    { name: "C2", value: "ff0000" },
  ],
  handball: [
    { name: "RW1", value: "2a4cd7" },
    { name: "6MR1", value: "814a19" },
    { name: "6MC1", value: "000000" },
    { name: "6ML1", value: "29d0d0" },
    { name: "LW1", value: "ad2224" },
    { name: "9MR1", value: "9dafff" },
    { name: "9MC1", value: "81c57a" },
    { name: "9ML1", value: "8126c0" },
    { name: "RW2", value: "1d6914" },
    { name: "6MR2", value: "e9debb" },
    { name: "6MC2", value: "575757" },
    { name: "6ML2", value: "000080" },
    { name: "LW2", value: "ffcdf3" },
    { name: "9MR2", value: "ffee32" },
    { name: "9MC2", value: "ff9233" },
    { name: "9ML2", value: "a0a0a0" },
    { name: "OUT", value: "ffffff" },
  ],
};

const fieldZones = {
  LW: { subType: "wing", location: "LEFT" },
  RW: { subType: "wing", location: "RIGHT" },
  "6ML": { subType: "sixMetre", location: "LEFT" },
  "6MR": { subType: "sixMetre", location: "RIGHT" },
  "6MC": { subType: "sixMetre", location: "CENTRE" },
  "9ML": { subType: "nineMetre", location: "LEFT" },
  "9MR": { subType: "nineMetre", location: "RIGHT" },
  "9MC": { subType: "nineMetre", location: "CENTRE" },
};

const componentToHex = (c) => {
  const hex = c.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
};

const rgbToHex = (r, g, b) => [r, g, b].map(componentToHex).join("");

// This assumes we get position in game coordinate system, so home on the left.
const getRegion = (posX, posY, sport, imageId = "base-play-area-regions") => {
  const regions = regionsForSport[sport] ?? [];
  const img = document.getElementById(imageId);
  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const pointX = (canvas.width / 100) * posX;
  const pointY = (canvas.height / 100) * posY;

  canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);
  const pixelData = canvas.getContext("2d").getImageData(pointX, pointY, 1, 1).data;
  canvas.remove();
  const region = regions.find((r) => r.value === rgbToHex(pixelData[0], pixelData[1], pixelData[2]));

  return region ? region.name : "M";
};

// given a team object and a region code returns an object of metadata related to that
const getRegionData = (team, region) => {
  const result = {};

  if ((team.isHome && region.at(-1) !== "2") || (!team.isHome && region.at(-1) !== "1")) {
    result.subType = "backCourt";
  } else {
    const regionZone = region.slice(0, region.length - 1);
    result.subType = fieldZones[regionZone].subType;
    result.location = fieldZones[regionZone].location;
  }

  return result;
};

const getBasketballShotType = (region, isHome, pointsFourAllowed = false) => {
  const teamRegion = isHome ? "1" : "2";
  if (region === `P${teamRegion}` || region === `C${teamRegion}`) {
    return "2pt";
  }
  if (!pointsFourAllowed || region === `T${teamRegion}`) {
    return "3pt";
  }
  return "4pt";
};

// Given an x and y of a point and the current entities array transforms it from view to game coordinates and back.
// The operation is commutative, that's why we can go from view to game, and from game to view with the same logic.
// View coordinate system is what the user sees right now, game coordinate system assumes home is on the left always.
const transformViewGamePosition = (posX, posY, entities) => {
  const isHomeTeamDisplayedOnRight = entities[1].isHome;
  if (isHomeTeamDisplayedOnRight) {
    return { x: parseFloat((100 - posX).toFixed(2)), y: parseFloat((100 - posY).toFixed(2)) };
  } else {
    return { x: posX, y: posY };
  }
};

export default { getRegion, getRegionData, getBasketballShotType, transformViewGamePosition };
